import React, { createContext, useContext, useState, useEffect } from 'react';

var CartContext = createContext();

var STORAGE_KEY = 'jimendez_cart_v2';

function loadStored() {
  try {
    var raw = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (!raw) return [];
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) { return []; }
}

export function CartProvider({ children }) {
  var state = useState(loadStored);
  var items = state[0];
  var setItems = state[1];
  var openState = useState(false);
  var isOpen = openState[0];
  var setIsOpen = openState[1];

  useEffect(function() {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
  }, [items]);

  function addItem(product, variant, options) {
    options = options || {};
    var unitPrice = options.unitPrice !== undefined && options.unitPrice !== null ? options.unitPrice : product.price;
    var isDigital = options.isDigital !== undefined ? options.isDigital : (product.category === 'sheet-music');
    var variantImage = options.variantImage || null;
    setItems(function(prev) {
      var key = product.slug + '|' + (variant || '') + '|' + unitPrice;
      var existing = prev.find(function(i) { return i.key === key; });
      if (existing) {
        // A digital file is bought once: adding it again must not make it two.
        if (isDigital) return prev;
        return prev.map(function(i) {
          return i.key === key ? Object.assign({}, i, { qty: i.qty + 1 }) : i;
        });
      }
      return prev.concat([{
        key: key,
        product: product,
        variant: variant || null,
        unitPrice: unitPrice,
        isDigital: isDigital,
        variantImage: variantImage,
        qty: 1,
      }]);
    });
    setIsOpen(true);
  }

  function removeItem(key) {
    setItems(function(prev) { return prev.filter(function(i) { return i.key !== key; }); });
  }

  function updateQty(key, qty) {
    if (qty < 1) { removeItem(key); return; }
    setItems(function(prev) {
      return prev.map(function(i) {
        if (i.key !== key) return i;
        return Object.assign({}, i, { qty: i.isDigital ? 1 : qty });
      });
    });
  }

  function clearCart() { setItems([]); }

  var totalItems = 0;
  var subtotal = 0;
  for (var i = 0; i < items.length; i++) {
    totalItems += items[i].qty;
    subtotal += (items[i].unitPrice || items[i].product.price || 0) * items[i].qty;
  }

  var hasPhysical = items.some(function(i) { return !i.isDigital; });
  var hasDigital = items.some(function(i) { return i.isDigital; });

  return React.createElement(CartContext.Provider, {
    value: {
      items: items,
      addItem: addItem,
      removeItem: removeItem,
      updateQty: updateQty,
      clearCart: clearCart,
      totalItems: totalItems,
      subtotal: subtotal,
      hasPhysical: hasPhysical,
      hasDigital: hasDigital,
      isOpen: isOpen,
      setIsOpen: setIsOpen
    }
  }, children);
}

export function useCart() { return useContext(CartContext); }
